/**
 * Created by marlon.jerez on 10/07/2016.
 */

import {navBar} from "../navBar/navbar";
import {topBanner} from "../topBanner/topBanner";
import {contactForm} from "../contactForm/contactForm"
import {storesMap} from "../storesMap/storesMap";
import {mainMenu} from "../menus/mainMenu";

declare const __monkberry_navigation: MonkberryCompiledTPL;
declare const $: any;
declare const MICROWORKS_URL: string;
declare const MICROWORKS_URL_MOB: string;
declare const MAIN_MENU: boolean;


export class App extends Backbone.Router {

	routes = {};

	navBar: navBar;
	topBanner: topBanner;
	contactform: contactForm;
	storesMap: storesMap;
	mainMenu: mainMenu;

	constructor() {
		super();
		(<any>this)._bindRoutes();
	}

	initialize(options) {
		this.navBar = new navBar();
		this.topBanner = new topBanner();
		this.contactform = new contactForm();
		this.initAllPages();
		this.orderNowbtn();
		this.mobileMicroworksLinks();
		this.initMainMenu();
		this.initStores();
		//this.disableCookieAPP();
		this.inStoreForm();
	}

	alb() {
		const state = {
			todos: [
				{text: 'Primum', complete: true},
				{text: 'Secundo', complete: false},
				{text: 'Tertium', complete: false}
			]
		};
		const view = Monkberry.render(__monkberry_navigation, document.body);
		view.update(state);
	}

	initAllPages() {
		jQuery(".dropdown-button").dropdown();
		jQuery('select').material_select();
		jQuery('.collapsible').collapsible();

	}


	initMainMenu() {
		if (typeof MAIN_MENU != 'undefined') {
			this.mainMenu = new mainMenu();
		}
	}


	orderNowbtn() {
		var btn = jQuery("#orderNow");
		if (btn.length) {
			var self = this; //typescript losing reference of this even using the arrow function
			var $doc = jQuery(document);
			let top = $doc.scrollTop();
			var btnState = (top <= 400);
			if (!btnState) {
				btn.addClass("active");
			}

			var showHideBtn = function () {
				// All the taxing stuff you do
				let top = $doc.scrollTop();
				var btnOFF = (top <= 400);
				if (btnOFF != btnState) {
					btnState = btnOFF;
					if (btnOFF == false) {
						//scrollTop over 400 => turn button on
						btn.addClass("active");
					} else {
						//scrollTop under 400 => turn button off
						btn.removeClass("active");
					}
				}
			};
			$doc.on("scroll", showHideBtn);
		}
	}


	initStores() {
		const nearesStores = jQuery(".nearest-stores");
		if (nearesStores.length) {
			nearesStores.find("tr").click(function () {
				window.location = jQuery(this).data('link');
			});
		}
	}

	mobileMicroworksLinks() {
		var rewriteLinks = function () {
			var microworkLinks = jQuery("a[href*='weborder3.microworks.com']");
			if (jQuery(window).width() > 720) {
				//desktop
				microworkLinks.attr("href", MICROWORKS_URL);
			} else {
				//mobile
				microworkLinks.attr("href", MICROWORKS_URL_MOB);
			}
		};
		var rewriteDebounced = debounce(rewriteLinks, 500);
		rewriteLinks();
		jQuery(window).resize(rewriteDebounced);
	}


	disableCookieAPP() {
		// if (jQuery("body.app_mode").length) {
		// 	setCookie("cookieconsent_dismissed", "yes", 999);
		// }
	}


	inStoreForm() {
		const instoreForm = jQuery(".in-store-form");
		const dInput = jQuery("#input_3_5");

		if (dInput.length && instoreForm.length) {
			dInput.datepicker({
				changeMonth: true,
				changeYear: true,
				dateFormat: 'dd/mm/yy',
				yearRange: '-100:-12',
				defaultDate: '-18y'
			});
			dInput.datepicker('refresh');

			jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
				jQuery('body').animate({
					scrollTop: 0
				}, 500);
			});
		}

		//phone transform tetx into number
		//disabled  becouse a bug when entering a non number then form can't be subbmited
		if (instoreForm.length && false) {

			jQuery(document).bind('gform_post_render', function(){
				transform();
			});

		}
	}

}

function transform(){
	const phoneI = jQuery("#input_3_9");
	if(phoneI.attr("type") != "number"){
		phoneI.clone().attr('type','number').insertAfter(phoneI).prev().remove();
	}
	console.log("transform");
}


function debounce(func: () => void, wait: number, immediate?: boolean) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	const expires = "expires=" + d.toUTCString();
	const aux = cname + "=" + cvalue + ";" + expires + ";path=/";
	document.cookie = aux;
}

new App();
Backbone.history.start();
